export default __webpack_public_path__ + "static/media/loadLogo.08739d79.png";